import React from 'react';
import { observer } from 'mobx-react';
import VendorProductList from '../../vendor-product-list';

export const VendorProducts = observer(() => {
    return <VendorProductList />;
});
